module.exports = __webpack_public_path__ + "img/BACK_ARROW_YELLOW.0b281471.svg";